import { useSelector } from 'react-redux';
import { getCartCount, getCartItems, getCartSum } from '../../cart/cart-reducer';
import { useProject } from './useProject';

export const useCart = () => {
    const project = useProject();
    const items = useSelector((state) => getCartItems(state, project.id)) || [];
    const sum = useSelector((state) => getCartSum(state, project.id));
    const count = useSelector((state) => getCartCount(state, project.id));

    return { sum, items, count };
};
